import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

/**
 * One destination in the bottom rail.
 *
 * The active highlight is a single shared element: every item that is
 * active renders `.rail__pill` under the same `layoutId`, so framer moves
 * one box from the old destination to the new one instead of fading a
 * box out here and another in over there. That slide is the main thing
 * that makes changing screens feel like one gesture.
 */
function SliderItem({ Icon, label, isActive, onClick }) {
    return (
        <motion.button
            type="button"
            className={`rail__item${isActive ? ' rail__item--active' : ''}`}
            onClick={onClick}
            aria-pressed={isActive}
            whileTap={{ scale: 0.94 }}
            transition={{ duration: 0.3, ease: EASE }}
        >
            {isActive && (
                <motion.span
                    className="rail__pill"
                    layoutId="rail-pill"
                    transition={{ type: 'spring', stiffness: 380, damping: 34 }}
                />
            )}

            <motion.span
                animate={{ scale: isActive ? 1.08 : 1, y: isActive ? -1 : 0 }}
                transition={{ duration: 0.45, ease: EASE }}
            >
                <Icon className="rail__icon" aria-hidden="true" />
            </motion.span>

            <span className="rail__label">{label}</span>
        </motion.button>
    );
}

export default SliderItem;
